import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomePageView, { SharedContentKind } from '../home/home-page-view';
import {
  buildIntentUrl,
  buildMockLocAppUri,
  tryOpenMockLocApp,
  websiteFallbackUrl,
} from './openMockLocApp';

function shareKindFromPath(pathname: string): SharedContentKind | undefined {
  if (pathname.startsWith('/dl-stpoint')) {
    return 'point';
  }
  if (pathname.startsWith('/dl-playlist-points')) {
    return 'playlist';
  }
  if (pathname.startsWith('/dl-itinerary')) {
    return 'itinerary';
  }
  return undefined;
}

const Deeplink: React.FC = () => {
  const { pathname, search } = useLocation();
  const appUri = buildMockLocAppUri(pathname, search);
  const openInAppHref = appUri
    ? buildIntentUrl(appUri, websiteFallbackUrl())
    : undefined;

  useEffect(() => {
    tryOpenMockLocApp(pathname, search);
  }, [pathname, search]);

  return (
    <HomePageView
      skipAuthRedirect
      shareKind={shareKindFromPath(pathname)}
      openInAppHref={openInAppHref}
    />
  );
};

export default Deeplink;
